import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Plus, X, SearchIcon } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import formFields from "Common/Components/formFieldsRegisterDriver";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import RegisterDriverColumn from "Common/Components/RegisterDriver/RegsiterDriver";
import RegisterForDriverColumn from "Common/Components/RegisterDriver/ColumnForDriver";
import { getRoleId, getUsername } from "Common/Components/getRoleId";
import DriverFormModal from "Common/Components/RegisterDriverModal/DriverFormModal";

interface FormField {
  name: string;
  label: string;
  type: string;
  placeholder: string;
  colSpan: any;
}

const Registerdriver = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [name, setname] = useState<any>();
  const [last_name, setlast_name] = useState<any>();
  const [national_code, setnational_code] = useState<any>();
  const [phone_number, setphone_number] = useState<any>();
  const [car_id, setcar_id] = useState<any>();
  const [license_plate, setlicense_plate] = useState<any>();
  const [capacity_ton, setcapacity_ton] = useState<any>();
  const [IsEdit, setIsEdit] = useState<any>();
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [searchInput, setSearchInput] = useState<string>("");
  const [carsList, setCarsList] = useState<any>([]);
  const [selectedCarName, setSelectedCarName] = useState<any>(null);
  const [deriverID, setderiverID] = useState<any>(null);
  const [plateData, setPlateData] = useState({
    region: "",
    letter: "ل",
    numeric: "",
    ending: "",
  });
  const token = localStorage.getItem("app_atkey");
  const getroleId = getRoleId(token);

  const handleRegionChange = (e: any) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 2) {
      setPlateData({ ...plateData, region: value });
    }
  };

  const handleNumericChange = (e: any) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 3) {
      setPlateData({ ...plateData, numeric: value });
    }
  };

  const handleEndingChange = (e: any) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 2) {
      setPlateData({ ...plateData, ending: value });
    }
  };

  const handleLetterSelect = (letter: string) => {
    setPlateData({ ...plateData, letter });
  };

  // تابع برای ساخت شماره پلاک کامل
  const getFullLicensePlate = () => {
    return `${plateData.region}ایران${plateData.numeric}${plateData.letter}${plateData.ending}`;
  };

  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;
    const totalItems = alldata ? Number(alldata) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize);
    setCurrentPage(newPage);
    fetchData(newPage, newSize);
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Get Data
  const fetchData = async (page: any, size: any) => {
    const userID = getUsername(token);
    const cropID = localStorage.getItem("crop_year_id");
    try {
      setload(true)
      let url;
      if (getroleId === 1) {
        url = `https://api.havirkesht.ir/driver/?sort_by=updated_at&sort_order=desc&size=${size}&page=${page}&crop_year_id=${cropID}`;
      } else {
        url = `https://api.havirkesht.ir/driver/by_user/${userID}`;
      }
      if (searchValue && searchValue.trim() !== "") {
        url += `&search=${encodeURIComponent(searchValue.trim())}`;
      }
      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      if (getroleId === 1) {
        const items = res?.data?.items || [];
        setData(items);
        setalldata(res?.data?.total);
        setTotalPages(res?.data?.pages);
        setload(items.length < 1);
      } else {
        setData((prevData: any) => [res.data]);
        setload(false);
        setalldata(data?.length);
      }
    } catch (error: any) {
      setData("");
      console.error("Error fetching data:", error);
      setErrorMessage(
        error.response
          ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
          : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
      );
      setload(false);
    }
  };

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    console.log(cell);
    if (cell.id) {
      setEventData([
        {
          id: cell.id,
        },
        {
          national_code: cell.national_code,
        },
      ]);
    }
  };

  const handleDelete = async () => {
    if (!eventData) {
      toast.error("داده‌ای برای حذف انتخاب نشده است");
      setDeleteModal(false);
      return;
    }
    try {
      setDeleteModal(false);
      const DriverID = eventData[0]?.id;
      const nationalCodeID = eventData[1]?.national_code;
      const res = await axios.delete(
        `https://api.havirkesht.ir/driver/${DriverID}`
      );
      if (res.status === 200) {
        Swal.fire({
          title: "حذف راننده",
          text: "عملیات حذف با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      }
      await axios.delete(
        `https://api.havirkesht.ir/users/by_username/${nationalCodeID}`
      );
    } catch (error: any) {
      console.log(error);
      if (error.response) {
        toast.error("خطا در ارسال درخواست");
      }
    } finally {
      setEventData(null);
    }
  };

  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setname(ele?.name);
    setlast_name(ele?.last_name);
    setnational_code(ele?.national_code);
    setphone_number(ele?.phone_number);
    setcar_id(ele?.car_id);
    setlicense_plate(ele?.license_plate);
    setderiverID(ele.id);
    setcapacity_ton(ele?.capacity_ton);
    const carToEdit = carsList.find((car: any) => car.id === ele.car_id);
    setSelectedCarName(carToEdit || null);
    if (ele.license_plate) {
      try {
        const plateRegex = /^(\d{2})ایران(\d{3})([آ-ی])(\d{2})$/;
        const match = ele.license_plate.match(plateRegex);
        if (match) {
          setPlateData({
            region: match[1],
            numeric: match[2],
            letter: match[3],
            ending: match[4],
          });
        }
      } catch (error) {
        console.error("Error parsing license plate:", error);
      }
    }
    setShow(true);
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (
      !plateData.region ||
      !plateData.numeric ||
      !plateData.letter ||
      !plateData.ending
    ) {
      Swal.fire("خطا", "لطفا تمام قسمت‌های شماره پلاک را تکمیل کنید", "error");
      return;
    }
    validation.handleSubmit();
  };

  useEffect(() => {
    const fetchDataCars = async () => {
      const cropYear = localStorage.getItem("crop_year_id");
      try {
        let url = `https://api.havirkesht.ir/cars/?crop_year_id=${cropYear}&sort_by=updated_at&sort_order=desc`;
        if (searchInput) {
          url += `&search=${encodeURIComponent(searchInput)}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
          },
        });
        setCarsList(response.data?.items || []);
      } catch (error: any) {
        console.error("Error fetching farmers data:", error);
      }
    };
    fetchDataCars();
  }, [searchInput]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: IsEdit ? name || "" : "",
      last_name: IsEdit ? last_name || "" : "",
      national_code: IsEdit ? national_code || "" : "",
      phone_number: IsEdit ? phone_number || "" : "",
      car_id: IsEdit ? car_id || "" : "",
      license_plate: IsEdit ? license_plate || "" : "",
      capacity_ton: IsEdit ? capacity_ton || "" : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("نام ضروری است"),
      last_name: Yup.string().required("نام خانوادگی ضروری است"),
      national_code: Yup.string()
        .required("کد ملی ضروری است")
        .matches(/^[0-9]{10}$/, "کد ملی باید 10 رقم باشد"),
      phone_number: Yup.string()
        .required("شماره تماس ضروری است")
        .matches(/^[0-9]{11}$/, "شماره تماس باید 11 رقم باشد"),
      capacity_ton: Yup.number().required("ظرفیت بار ضروری است"),
    }),
    onSubmit: async (values) => {
      if (!selectedCarName) {
        return Swal.fire("خطا در ارسال", "لطفا خودرو را انتخاب کنید", "error");
      }
      // ساخت شماره پلاک کامل
      const fullLicensePlate = getFullLicensePlate();

      try {
        if (IsEdit) {
          const updateData = {
            ...values,
            car_id: Number(selectedCarName?.id),
            license_plate: fullLicensePlate,
          };
          const res = await axios.put(
            `https://api.havirkesht.ir/driver/${deriverID}`,
            updateData
          );
          if (res.status === 200) {
            Swal.fire({
              title: "بروزرسانی داده",
              text: "اطلاعات با موفقیت بروزرسانی شد",
              icon: "success",
            });
            setreload((prev) => !prev);
            resetForm();
          }
        } else {
          const newData = {
            ...values,
            car_id: Number(selectedCarName?.id),
            license_plate: fullLicensePlate,
          };
          console.log(newData);

          const res = await axios.post(
            "https://api.havirkesht.ir/driver/",
            newData
          );
          const newrest2 = {
            username: values.national_code,
            password: values.national_code,
            fullname: `${values.name}  ${values.last_name}`,
            email: `${values.national_code}@gimail.com`,
            role_id: 5,
            phone_number: values.phone_number,
            disabled: false,
          };
          const newres = await axios.post(
            "https://api.havirkesht.ir/users/admin/",
            newrest2
          );
          console.log(newrest2);
          console.log(newres);
          if (res.status === 201) {
            Swal.fire({
              title: "ثبت داده",
              text: "اطلاعات با موفقیت ثبت شد",
              icon: "success",
            });
            setreload(!reload);
            resetForm();
          }
        }
      } catch (error: any) {
        console.log("Error:", error);
        Swal.fire({
          title: "ثبت داده",
          text: "خطا در ثبت داده به وجود آمده است",
          icon: "error",
        });
      }
    },
  });

  function resetForm() {
    setIsEdit(false);
    setShow(false);
    setEventData("");
    validation.resetForm();
    setname("");
    setlast_name("");
    setnational_code("");
    setphone_number("");
    setcar_id("");
    setlicense_plate("");
    setderiverID("");
    setcapacity_ton("");
    setSelectedCarName("");
    setPlateData({
      region: "",
      letter: "ل",
      numeric: "",
      ending: "",
    });
  }

  const toggle = useCallback(() => {
    if (show) {
      resetForm();
    } else {
      setShow(true);
    }
  }, [show]);

  const columns =
    getroleId === 1
      ? RegisterDriverColumn({
          handleUpdateDataClick,
          onClickDelete,
        })
      : RegisterForDriverColumn({});

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت راننده" title="هاویر کشت" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex flex-col gap-4 mb-4 md:flex-row md:items-center md:justify-between">
            <div className="w-full md:w-auto">
              <h6 className="text-15 mb-2">
                مجموع رانندگان (
                <b className="total-Employs">{alldata?.toString()}</b>)
              </h6>

              <label className="flex flex-col gap-2 mb-2 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                    {searchValue ? (
                      <X
                        size={15}
                        className="cursor-pointer"
                        onClick={() => setsearchValue("")}
                      />
                    ) : (
                      <SearchIcon size={15} />
                    )}
                  </span>
                </div>
              </label>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
              <div className="w-full sm:w-auto">
                <TableDropDownSmall onSelect={handleSelect} />
              </div>
              <div className="w-full sm:w-auto shrink-0">
                {getRoleId(token) === 1 ? (
                  <Link
                    to="#"
                    onClick={toggle}
                    type="button"
                    className="block text-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
                  >
                    <span className="align-middle rtl">ایجاد راننده جدید</span>{" "}
                    <Plus className="inline-block size-4 rtl" />
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={9}
             customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap "
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 dark:text-white first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5  last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}

          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <DriverFormModal
        show={show}
        isEdit={IsEdit}
        onHide={toggle}
        onSubmit={handleClick}
        validation={validation}
        formFields={formFields}
        carsList={carsList}
        selectedCarName={selectedCarName}
        setSelectedCarName={setSelectedCarName}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        plateData={plateData}
        handleRegionChange={handleRegionChange}
        handleNumericChange={handleNumericChange}
        handleEndingChange={handleEndingChange}
        handleLetterSelect={handleLetterSelect}
      />
    </React.Fragment>
  );
};

export default Registerdriver;
